import React, { useState } from "react";
import { register } from "../api/auth";
import toast from "react-hot-toast";
import TextInput from "./ui/TextInput";
import Button from "./ui/Button";

export default function RegisterForm({ onSuccess }) {
  const [form, setForm] = useState({ email: "", username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(form);
      toast.success("Registration successful! Please check your email to verify your account.");
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.error || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 sm:gap-5 items-center w-full">
      <TextInput
        name="email"
        type="email"
        label="Email"
        placeholder="you@example.com"
        icon="📧"
        value={form.email}
        onChange={handleChange}
        required
      />

      <TextInput
        name="username"
        type="text"
        label="Username"
        placeholder="Pick a username"
        icon="🎮"
        value={form.username}
        onChange={handleChange}
        required
      />

      <TextInput
        name="password"
        type={showPassword ? "text" : "password"}
        label="Password"
        placeholder="••••••••"
        icon="🔒"
        value={form.password}
        onChange={handleChange}
        required
        endAdornment={
          <button
            type="button"
            onClick={handleClickShowPassword}
            aria-label="toggle password visibility"
            className="text-white/50 hover:text-brand-gold transition-colors p-1"
          >
            {showPassword ? "🙈" : "👁"}
          </button>
        }
      />

      <Button type="submit" variant="primary" size="lg" className="w-full" disabled={loading}>
        {loading ? (
          <>
            <span className="h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin" />
            Creating Account...
          </>
        ) : (
          "Create Account →"
        )}
      </Button>

      {error && <p className="text-red-400 text-center text-sm mt-1">{error}</p>}
    </form>
  );
}
